export default __webpack_public_path__ + "static/airbnb-5-bf9c0049d7a1978ce1862055b062fdcb.png";